// Package Imports
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

// Services
import { AuthorizationService } from '../../services/authorization/authorization.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {
  constructor(private readonly authorizationService: AuthorizationService) { }

  canActivate(): Observable<boolean> {
    return from(this.authorizationService.isLoggedIn()).pipe(map(r => {
      if (r) {
        return true;
      }

      this.authorizationService.startAuthentication();

      return false;
    }));
  }
}
